import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import './components/Header.css';
import App from './App';
import { AuthProvider } from './AuthContext';
import reportWebVitals from './reportWebVitals';

const baseEnv = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const hostname = window.location.hostname;
const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';

const resolveApiBase = () => {
  if (isLocalHost) return '';
  if (!baseEnv) return '';
  try {
    const envUrl = new URL(baseEnv);
    if (envUrl.origin === window.location.origin) return '';
    return baseEnv;
  } catch {
    return baseEnv;
  }
};

const runtimeApiBase = resolveApiBase();

axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  const url = config.url || '';
  if (!url) return config;

  if (runtimeApiBase && url.startsWith('/api')) {
    config.url = `${runtimeApiBase}${url}`;
    return config;
  }

  if (!runtimeApiBase && baseEnv && url.startsWith(baseEnv)) {
    const stripped = url.slice(baseEnv.length);
    config.url = stripped.startsWith('/') ? stripped : `/${stripped}`;
    return config;
  }

  return config;
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
